$ = require 'jquery'
Dates = require 'lib/dates'
DragSort = require 'views/lib/drag-sort'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
moment = require 'moment'
localizeCount = require 'lib/localize-count'

module.exports = class CalendarDayView extends View

  events:
    'sortreceive': 'sortReceive'
    'sortstop': 'sortStop'
    'click .js-expand-day:not(.active)': 'expand'
    'click .js-toggle-day': 'clickToggleDay'

  initialize: ({ @data, @getCardView }) ->
    @$el.attr('name', Dates.getMidnightInt(@data.day))
    @cardsDue = @data.cardsDueOnDate

  remove: ->
    # because retain cycles
    delete @getCardView
    super

  render: (data = {}) ->
    date = @data.day
    firstOrLastOfMonth = Dates.isFirstOfMonth(date) || Dates.isLastOfMonth(date)

    viewData =
      date: moment(date).format(if firstOrLastOfMonth then 'llll' else 'D')
      isToday: moment().isSame(date, 'day')

    _.extend data, viewData

    @$el.html(
      templates.fill('calendar_day', data, { editable: @model.editable() } )
    )

    @renderCardsAndHeaders()
    @

  renderCardsAndHeaders: ->
    @updateHeader()
    @renderCardsAndListHeaders()

  cardListMap: ->
    _.groupBy @cardsDue,
      (card) -> card.getList().id

  updateHeader: ->
    numCards = @cardsDue.length
    @$('.day-cards-header').empty()
    if numCards > 0
      @$('.day-cards-header').text localizeCount('cards', numCards)

  renderCardsAndListHeaders: ->
    $cardList = @$('.calendar-day-list')
    $cardList.empty()

    elementsToAppend = []
    for own listID, cards of @cardListMap()
      # Use existing listHeader or render a new one?
      headerData =
        listID: listID
        listName: @model.getList(listID).get('name')
      headerEl = templates.fill('calendar_day_list_header', headerData)
      elementsToAppend.push(headerEl)
      for card in cards
        cardView = @getCardView(card)
        if !cardView.$el.hasClass('ui-sortable-helper')
          cardViewEl = cardView.render().el
          $(cardViewEl).attr('name', card.cid)
          cardView.delegateEvents()
          elementsToAppend.push(cardViewEl)

    $cardList.append(elementsToAppend)

    if @model.editable()
      DragSort.refreshIfInitialized(@$('.js-calendar-sortable'))

  sortReceive: (e, ui) ->
    isInsideDragArea = (point) ->
      hoveredEl = document.elementFromPoint(point.left, point.top)
      $('.calendar-drag-area')[0].contains hoveredEl

    if isInsideDragArea(ui.offset)
      ui.item.trigger('moveToCalendarDay', [ui, @])
    else
      DragSort.abort()
      DragSort.refreshIfInitialized(@$('.js-calendar-sortable'))

  sortStop: (e, ui) ->
    ui.item.trigger('moveInCalendarDay', [ui, @])

  clickToggleDay: (e) ->
    if @$('.calendar-day').hasClass('active')
      @contract(e)
    else
      @expand(e)

  expand: (e) ->
    Util.stop(e)

    # We don't want to use the click event if we're in the middle of
    # dragging.  Observed in Firefox, not Chrome, due to a different order
    # in which the mouse events fire. If you fix it, fix it in all places
    # 1. Here
    # 2. DragSort.coffee > endSort() > the _.defer line
    # 3. All instances of doClicks() in card.coffee
    if DragSort.sorting
      return

    # Not great, but the alternative is some silly mass event propagation with
    # dubious performance. Let's be practical.
    $('.calendar-day.active').removeClass('active')

    $day = @$('.calendar-day').addClass('active')

    # Hide cardDetailMenu popovers
    PopOver.hide()

  contract: (e) ->
    Util.stop(e)
    @$('.calendar-day').removeClass('active')
    PopOver.hide()



// WEBPACK FOOTER //
// ./app/scripts/views/calendar/calendar-day-view.coffee